import { cn } from "src/lib/utils";
import { ErrorMessage } from "formik";
import { useState } from "react";
import { Button } from "./ui/button";
import { EyeIcon, EyeSlash } from "src/svg";

const CustomInput = ({ icon, label, containerClassName, labelClassName, innerContainerClassName, showPasswordToggle, children, ...props }) => {
	const [passwordVisible, setPasswordVisible] = useState(false);
	const togglePasswordVisibility = () => setPasswordVisible((prev) => !prev);

	return (
		<div className={containerClassName}>
			{!!label && (
				<label htmlFor={props["id"]} className={cn("tw-mb-1 tw-block tw-text-sm tw-font-medium tw-text-[#333333]", labelClassName)}>
					{label}
				</label>
			)}
			<div
				className={cn(
					"tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-[#008080] tw-text-sm has-[:focus]:tw-border-primary has-[:focus]:tw-ring-2 has-[:focus]:tw-ring-primary has-[:focus]:tw-ring-offset-2 has-[:disabled]:tw-bg-[#FBFBFB]",
					props.type === "password" ? "tw-relative" : "",
					innerContainerClassName,
				)}
			>
				{icon && <span className="tw-pl-3">{icon}</span>}
				{props.type === "password" ? (
					<>
						<input
							className={cn(
								"tw-w-full tw-rounded-md !tw-border-0 tw-py-3.5 tw-text-sm !tw-outline-0 tw-placeholder:tw-text-[#a8b0bd] focus:![--tw-ring-shadow:transparent] tw-disabled:tw-cursor-not-allowed tw-disabled:tw-bg-[#FBFBFB]",
								!!icon ? "tw-px-2" : "tw-px-5",
								props.className,
							)}
							{...props}
							type={passwordVisible ? "text" : "password"}
						/>
						{showPasswordToggle && (
							<Button
								size="icon"
								variant="ghost"
								type="button"
								className="tw-position-center-y tw-absolute tw-right-1 tw-max-h-[80%] tw-rounded-full tw-text-[#737D8F]"
								onClick={togglePasswordVisibility}
							>
								{passwordVisible ? <EyeIcon className="tw-size-5" /> : <EyeSlash className="tw-size-5" />}
							</Button>
						)}
					</>
				) : (
					<input
						{...props}
						className={cn(
							"tw-w-full tw-rounded-md !tw-border-0 tw-p-0 tw-py-3.5 tw-text-sm !tw-outline-0 tw-placeholder:tw-text-[#a8b0bd] focus:![--tw-ring-shadow:transparent] tw-disabled:tw-cursor-not-allowed tw-disabled:tw-bg-[#FBFBFB]",
							!!icon ? "tw-px-2" : "tw-px-5",
							props["className"],
						)}
					/>
				)}
			</div>
			{children}
			{!!props["name"] && <ErrorMessage name={props["name"]} component="div" className="tw-block tw-mt-1 tw-text-xs tw-text-destructive" />}
		</div>
	);
};

export default CustomInput;
